import { Component, OnInit } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { SMPComment } from '@app/shared/models/comment';
import { CaseCommentsService } from '@app/core/services/case-comments.service';
import { CaseLawyerReadonlyComponent } from '@app/modules/case/components/case-lawyer/readonly/case-lawyer-readonly.component';
import { FileType } from '@app/shared/models/file-type';
import { ContentStoreService } from '@app/core/services/content-store.service';

@Component({
    selector: 'case-lawyer-editable',
    templateUrl: './case-lawyer-editable.component.html',
    styleUrls: ['./case-lawyer-editable.component.scss']
})
export class CaseLawyerEditableComponent extends CaseLawyerReadonlyComponent
                                         implements OnInit {

    public acceptedFileTypes: FileType[];

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected caseCommentsService: CaseCommentsService,
                protected contentStoreService: ContentStoreService) {
        super(componentServiceBundle, caseCommentsService, contentStoreService);
    }

    public createComment(comment: string): void {
        const newComment = new SMPComment();
        newComment.comment = comment;

        this.caseCommentsService.create(this.generateCaseCommentsUriBuilder(), newComment)
                                .subscribe(result => {
            this.commentsList.addItem(result, true);
        });
    }

    public updateComment(comment: SMPComment): void {
        this.caseCommentsService.update(this.generateCaseCommentsUriBuilder(comment), comment)
                                .subscribe(result => {
            this.commentsList.replaceItem(result);
        });
    }

    public deleteComment(comment: SMPComment): void {
        this.caseCommentsService.delete(this.generateCaseCommentsUriBuilder(comment))
                                .subscribe(result => {
            this.commentsList.removeItem(comment);
        });
    }

}
